// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1sS5m","errorLogs":"styles_errorLogs__2TB-W"};